import ar from 'config/locales/ar.json';
import en from 'config/locales/en.json';

import { SiteLocale } from 'constants/i18n.constants';

export const messages = {
  [SiteLocale.AR]: ar,
  [SiteLocale.EN]: en,
};
